export class Voucher {
  documentType?: string;
  document?: string;
  queryCode?: string;
  base64?: string;

  public static fromResponse(json: any): Voucher {
    return {
      documentType: json['tipoDocumento'],
      document: json['documento'],
      queryCode: json['codigoConsulta'],
      base64: json['base64'],
    };
  }
}
